import React, { useEffect } from 'react';
import BreadCrumb from '../components/BreadCrumb';
import Footer from '../components/Footer';
import './Products.css';

const Products = () => {
  // 模拟Vue的onMounted生命周期
  useEffect(() => {
    // 这里可以添加初始化代码，比如initTheme
    // initTheme();
  }, []);

  return (
    <div className="products-page">
      <section className="bg-products relative bg-no-repeat bg-cover md:h-[400px] h-64 bg-center">
        <BreadCrumb className="absolute left-0 right-0 bottom-0" routeArr={[{ link: '/products', title: '产品矩阵' }]} />
      </section>

      <section>
        <div className="container pt-10 md:mt-16">
          <div className="md:flex">
            <div className="flex-1 md:w-0">
              <div className="text-2xl text-[#0087b2]">可学习模型和芯片</div>
              <div className="flex py-6 text-sm text-center justify-between">
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/cpu_theia.webp')} alt="忒亚Theia" />
                  <div className="mt-2">忒亚<br />Theia</div>
                </div>
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/cpu_hyperion.webp')} alt="许珀里翁Hyperion" />
                  <div className="mt-2">许珀里翁<br />Hyperion</div>
                </div>
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/cpu_oceanus.webp')} alt="欧申纳斯Oceanus" />
                  <div className="mt-2">欧申纳斯<br />Oceanus</div>
                </div>
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/cpu_uranus.webp')} alt="乌拉诺斯Uranus" />
                  <div className="mt-2">乌拉诺斯<br />Uranus</div>
                </div>
              </div>
            </div>
            <div className="flex-1 md:w-0 md:ml-16">
              <div className="text-2xl text-[#0087b2]">解决方案</div>
              <div className="flex py-6 text-sm text-center justify-between">
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/computer_networks.webp')} alt="盖亚GAIA" />
                  <div className="mt-2">盖亚<br />GAIA</div>
                </div>
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/smart_city.webp')} alt="忒弥斯Theis" />
                  <div className="mt-2">忒弥斯<br />Theis</div>
                </div>
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/robot_cooking_in_the_kitchen.webp')} alt="福伯Phobe" />
                  <div className="mt-2">福伯<br />Phobe</div>
                </div>
                <div>
                  <img className="w-16 h-16" src={require('../assets/img/uav_robot.webp')} alt="瑞亚Rhea" />
                  <div className="mt-2">瑞亚<br />Rhea</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex md:flex-row flex-col-reverse mt-10 md:mt-20">
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                可学习自动控制模型和芯片（忒亚Theia）
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                忒亚Theia是世界上第一款基于人工智能技术实现的自动控制器，也是第一个将人工智能的应用领域推广到自动控制领域的模型和芯片。忒亚Theia可以实现媲美和现有的基于自动控制理论来实现的自动控制器和自动控制设备，同时大幅度降低自动控制技术的调试成本。忒亚Theia甚至可以利用现实场景中的信息，让自动控制效果更好，性能的鲁棒性更强。
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/cpu_theia.webp')} alt="忒亚Theia" />
            </div>
          </div>

          <div className="flex md:flex-row flex-col mt-10 md:mt-20">
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/cpu_hyperion.webp')} alt="许珀里翁Hyperion" />
            </div>
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                可学习随动控制模型和芯片（许珀里翁Hyperion）
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                Samna is the developer interface to the SynSense toolchain and run-time environment for interacting with all SynSense devices.
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
          </div>

          <div className="flex md:flex-row flex-col-reverse mt-10 md:mt-20">
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                可学习模型和芯片I型（欧申纳斯Oceanus）
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                Samna is the developer interface to the SynSense toolchain and run-time environment for interacting with all SynSense devices.
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/cpu_oceanus.webp')} alt="欧申纳斯Oceanus" />
            </div>
          </div>

          <div className="flex md:flex-row flex-col mt-10 md:mt-20">
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/cpu_uranus.webp')} alt="乌拉诺斯Uranus" />
            </div>
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                可学习模型芯片II型（乌拉诺斯Uranus）
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                Samna is the developer interface to the SynSense toolchain and run-time environment for interacting with all SynSense devices.
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
          </div>

          <div className="flex md:flex-row flex-col-reverse mt-10 md:mt-20">
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                GAIA人工智能开发平台（盖亚gaia）
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                盖亚gaia是新一代人工智能技术模型的开发和训练平台。盖亚gaia基于新的人工智能技术理论，相比于传统的人工智能开发平台，如Pytorch、TensorFlow等，在底层模块上和上层训练上都有所不同。盖亚gaia人工智能技术开发平台致力于提高人工智能模型的开发效率，帮助推广真正的人工智能技术。
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/computer_networks.webp')} alt="盖亚GAIA" />
            </div>
          </div>

          <div className="flex md:flex-row flex-col mt-10 md:mt-20">
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/smart_city.webp')} alt="忒弥斯Theis" />
            </div>
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                智慧城市解决方案(忒弥斯Theis)
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                Samna is the developer interface to the SynSense toolchain and run-time environment for interacting with all SynSense devices.
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
          </div>

          <div className="flex md:flex-row flex-col-reverse mt-10 md:mt-20">
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                智慧家居解决方案(福伯Phobe)
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                Samna is the developer interface to the SynSense toolchain and run-time environment for interacting with all SynSense devices.
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/robot_cooking_in_the_kitchen.webp')} alt="福伯Phobe" />
            </div>
          </div>

          <div className="flex md:flex-row flex-col mt-10 md:mt-20">
            <div className="flex-1 max-w-[400px] p-6">
              <img src={require('../assets/img/uav_robot.webp')} alt="瑞亚Rhea" />
            </div>
            <div className="flex-1">
              <div className="text-xl md:text-3xl">
                配送机器人解决方案(瑞亚Rhea)
              </div>
              <div className="mt-6 text-md md:text-xl leading-relaxed">
                Samna is the developer interface to the SynSense toolchain and run-time environment for interacting with all SynSense devices.
              </div>
              <div className="mt-6 text-gray-500">
                Developed towards efficiency and to be user-friendly, a Python API is available with the core running in C++. It is possible to work with neuromorphic devices professionally and elegantly. Samna also features an event-based stream filter system that allows real-time, multi-branch processing of the event-based stream coming in or out from the device. With an integration of a just-in-time compiler in Samna, the flexibility of this filter system has been taken to an even higher dimension, which supports adding user-defined filter functions at run-time to meet the requirements of many different scenarios.
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer className="md:pt-28 pt-16" />
    </div>
  );
};

export default Products;